module.exports = __webpack_public_path__ + "bttBtnArrow-a518df8f0a881362953fab353fe93d1a.svg";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bttBtnArrow.svg
// module id = 3TFB
// module chunks = client